import { useState } from "react";
import { Bars3Icon } from "@heroicons/react/20/solid";
import MobileHeaderMenu from "./MobileHeaderMenu";
import { MenuLink, AppSection } from ".";

// Update Props to use MenuLink from index.tsx and include onSectionChange
type Props = {
  links: MenuLink[];
  onSectionChange?: (section: AppSection) => void;
};

function MobileHeader({ links, onSectionChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="p-2 hover:bg-primary/10 rounded-lg transition-colors"
      >
        <Bars3Icon className="h-5 w-5" />
      </button>
      <MobileHeaderMenu
        links={links}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSectionChange={onSectionChange}
      />
    </>
  );
}

export default MobileHeader; 